import React from 'react';
import { Pagination } from '@material-ui/lab';

const PaginationBase = ({ className, ...rest }) => {
    return <Pagination className={className} shape="rounded" color="primary" {...rest} />;
};

export default React.memo(PaginationBase);
